<template>
  <Badge :variant="INVOICE_STATUS_VARIANT[status]" :size="size">
    {{ t(`invoiceStatus.${status}`) }}
  </Badge>
</template>

<script setup lang="ts">
import Badge from '@/components/Badge.vue';
import { InvoiceStatus } from '@/entities/invoices/invoice-status.enum';
import type { BadgeVariant } from '@carvia/theme/lib/cva/badge';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps<{
  status: InvoiceStatus;
  size?: 'sm' | 'md';
}>();

const INVOICE_STATUS_VARIANT: Record<InvoiceStatus, BadgeVariant> = {
  [InvoiceStatus.OPEN]: 'success',
  [InvoiceStatus.DRAFT]: 'warning',
  [InvoiceStatus.PRELIMINARY]: 'warning',
  [InvoiceStatus.CANCELED]: 'problem',
};
</script>
